import { createFileRoute } from "@tanstack/react-router";
import { TeamsPage } from "@/app/connect/pages/teams";

type TeamsSearchParams = {
	provider_id?: string;
};

function cleanId(value: unknown): string | undefined {
	if (typeof value === "number") return String(value);
	if (typeof value === "string") {
		const cleaned = value.replace(/^["']|["']$/g, "");
		return cleaned || undefined;
	}
	return undefined;
}

export const Route = createFileRoute("/connect/teams")({
	validateSearch: (search: Record<string, unknown>): TeamsSearchParams => ({
		provider_id: cleanId(search.provider_id),
	}),
	component: TeamsPage,
});
